(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Constants                                                           */
  /* ------------------------------------------------------------------ */

  // Only used when a product picker is empty in the theme editor
  var FALLBACK_TITLES = {
    dark_cool: 'Spray Tan Formula Dark Cool',
    dark_warm: 'Spray Tan Formula Dark Warm',
    clear: 'Spray Tan Formula Clear',
    pro: 'Tanrevel Pro',
    one: 'Tanrevel One',
    go: 'Tanrevel Go',
    mousse_dark: 'Self Tan Mousse Dark',
    mousse_clear: 'Self Tan Mousse Clear',
    mousse_ultra_dark: 'Self Tan Mousse Ultra Dark',
    gradual_lotion: 'Gradual Tanning Lotion',
    night_mask: 'Self Tan Night Mask',
    scrub: 'Exfoliating Scrub',
    pads: 'Exfoliating Pads',
    mitt: 'Self Tan Mitt',
    headband: 'Headband',
    serum: 'Kroppsserum'
  };

  // Screen 1 is answered by POSITION, ordered from least to most colour:
  //   Alt 1 = least colour (t.ex. "Lätt solkysst")
  //   Alt 2 = medium      (t.ex. "Medium intensitet")
  //   Alt 3 = most colour (t.ex. "Maximal effekt")
  // The texts can be changed freely in the theme editor, but keep this order.
  var S1_KEYS_BY_POSITION = ['solkysst', 'sommarbrun', 'morkbrun'];

  // Screen 1: desired result -> intensity 1–3 (decides HOW MUCH colour the product gives)
  var INTENSITY = { solkysst: 1, sommarbrun: 2, morkbrun: 3 };

  // Screen 2: skin tone -> base depth 1–4
  var DEPTH_BY_SKIN = { ljus: 1, ljus_medium: 2, medium: 3, medium_mork: 4 };
  // Screen 1: desired tan -> depth adjustment (used to pick between Mousse Dark and Ultra Dark)
  var DEPTH_ADJUST = { morkbrun: 1, sommarbrun: 0, solkysst: -1 };

  var ADVANCE_DELAY = 350;

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null && text !== '') node.textContent = text;
    return node;
  }

  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function unique(list) {
    var seen = {};
    return list.filter(function (item) {
      if (seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ------------------------------------------------------------------ */
  /* Quiz instance                                                       */
  /* ------------------------------------------------------------------ */

  function QuizInstance(root) {
    this.root = root;
    this.app = root.querySelector('[data-skin-quiz-app]');
    var sectionId = root.getAttribute('data-section-id');
    var dataScript = document.querySelector('script[data-skin-quiz-data="' + sectionId + '"]');
    this.data = JSON.parse(dataScript.textContent);
    this.copy = this.data.copy;

    // Screen 1: map answers by position (least -> most colour), independent of the texts
    var s1 = this.data.screens && this.data.screens.s1;
    if (s1 && s1.options) {
      s1.options.forEach(function (opt, i) {
        if (S1_KEYS_BY_POSITION[i]) opt.key = S1_KEYS_BY_POSITION[i];
      });
    }

    this.reset();
  }

  QuizInstance.prototype.reset = function () {
    this.history = [];
    this.locked = false;
    this.state = { screen: 'start', answers: {}, knownUndertone: null, issues: [] };
    this.render();
  };

  /* ----------------------------- Products ----------------------------- */

  QuizInstance.prototype.product = function (key) {
    var p = this.data.products[key];
    return p && p.linked ? p : null;
  };

  QuizInstance.prototype.title = function (key) {
    var p = this.product(key);
    return p && p.title ? p.title : FALLBACK_TITLES[key] || key;
  };

  /* ---------------------------- Navigation ---------------------------- */

  QuizInstance.prototype.goTo = function (screen) {
    if (this.state.screen !== 'start') this.history.push(this.state.screen);
    this.state.screen = screen;
    this.render();
    this.scrollToTop();
  };

  QuizInstance.prototype.back = function () {
    if (!this.history.length) return;
    this.state.screen = this.history.pop();
    this.render();
    this.scrollToTop();
  };

  QuizInstance.prototype.scrollToTop = function () {
    var top = this.root.getBoundingClientRect().top;
    if (top < 0) {
      window.scrollTo({ top: window.pageYOffset + top - 80, behavior: 'smooth' });
    }
  };

  QuizInstance.prototype.render = function () {
    this.locked = false;
    this.app.innerHTML = '';
    this.app.classList.remove('skin-quiz__app--flush');

    var s = this.state.screen;
    if (s === 'start') return this.renderStart();
    if (s === 'shortcut') return this.renderShortcut();
    if (s === 'result') return this.renderResult();
    return this.renderQuestion(s);
  };

  /* ------------------------------ Logic ------------------------------- */

  QuizInstance.prototype.direction3 = function () {
    var a = this.state.answers[3];
    if (a === 'guld') return 'varm';
    if (a === 'silver') return 'kall';
    return null;
  };

  QuizInstance.prototype.direction4 = function () {
    var a = this.state.answers[4];
    if (a === 'grona') return 'varm';
    if (a === 'bla') return 'kall';
    return null;
  };

  // Screen 5 only when jewellery and veins disagree, or "Vet inte" on screen 3
  QuizInstance.prototype.needsScreen5 = function () {
    if (this.state.knownUndertone) return false;
    if (this.state.answers[3] === 'vet_inte') return true;
    var d3 = this.direction3();
    var d4 = this.direction4();
    return !!(d3 && d4 && d3 !== d4);
  };

  // How much colour the customer WANTS (screen 1): 1 = least, 3 = most.
  QuizInstance.prototype.intensity = function () {
    return INTENSITY[this.state.answers[1]] || 2;
  };

  // Depth = skin tone (screen 2) + desired tan (screen 1), locked 1–4.
  // Only used to choose between Mousse Dark and Mousse Ultra Dark, never to downgrade to Gradual.
  QuizInstance.prototype.depth = function () {
    var a = this.state.answers;
    var d = (DEPTH_BY_SKIN[a[2]] || 2) + (DEPTH_ADJUST[a[1]] || 0);
    return Math.max(1, Math.min(4, d));
  };

  // Mousse / "föreslå" leads to Gradual only when the customer wants the least colour
  QuizInstance.prototype.wantsGradual = function () {
    return this.intensity() === 1;
  };

  // Screen 7 (guide colour) for spray tan, and for mousse when the result will be a mousse
  QuizInstance.prototype.needsScreen7 = function () {
    var p = this.state.answers[6];
    if (p === 'spray' || p === 'controlled') return true;
    if (p === 'mousse' || p === 'suggest') return !this.wantsGradual();
    return false;
  };

  // Scoring: jewellery 2 points, veins 1, white shirt 1. Difference of 2 wins, otherwise neutral.
  QuizInstance.prototype.undertone = function () {
    if (this.state.knownUndertone) return this.state.knownUndertone;
    var a = this.state.answers;
    var varm = 0;
    var kall = 0;

    if (a[3] === 'guld') varm += 2;
    if (a[3] === 'silver') kall += 2;
    if (a[4] === 'grona') varm += 1;
    if (a[4] === 'bla') kall += 1;
    if (this.needsScreen5()) {
      if (a[5] === 'graddvit') varm += 1;
      if (a[5] === 'helt_vit') kall += 1;
    }

    if (varm - kall >= 2) return 'varm';
    if (kall - varm >= 2) return 'kall';
    return 'neutral';
  };

  QuizInstance.prototype.nextScreen = function (from) {
    if (from === 1) return 2;
    if (from === 2) return 3;
    if (from === 3) return 4;
    if (from === 4) return this.needsScreen5() ? 5 : 6;
    if (from === 5) return 6;
    if (from === 6) return this.needsScreen7() ? 7 : 'result';
    return 'result';
  };

  // Screens this customer will see — used for "2 av 7"
  QuizInstance.prototype.plannedScreens = function () {
    var a = this.state.answers;
    var list = [1, 2, 3];

    if (!this.state.knownUndertone) {
      list.push(4);
      var maybe5;
      if (a[3] === undefined) maybe5 = true;
      else if (a[4] === undefined) maybe5 = a[3] !== 'bada';
      else maybe5 = this.needsScreen5();
      if (maybe5) list.push(5);
    }

    list.push(6);
    if (a[6] === undefined || this.needsScreen7()) list.push(7);
    return list;
  };

  /* ------------------------------ Start ------------------------------- */

  QuizInstance.prototype.renderStart = function () {
    var self = this;
    this.app.classList.add('skin-quiz__app--flush');

    var hero = el('div', 'sq-hero');

    if (this.copy.startImage) {
      var img = el('img', 'sq-hero__image');
      img.src = this.copy.startImage;
      img.alt = '';
      img.style.objectPosition = 'center ' + (this.copy.startImagePosition || 'center');
      hero.appendChild(img);
    } else {
      hero.appendChild(el('div', 'sq-hero__image--placeholder', 'Bild'));
    }

    var overlay = el('div', 'sq-hero__overlay');
    if (this.copy.startSubtext) overlay.appendChild(el('p', 'sq-hero__subtext', this.copy.startSubtext));

    var btn = el('button', 'sq-start__button', this.copy.startButton || 'Starta testet');
    btn.type = 'button';
    btn.addEventListener('click', function () {
      self.goTo(1);
    });
    overlay.appendChild(btn);

    hero.appendChild(overlay);
    this.app.appendChild(hero);
  };

  /* ----------------------------- Progress ----------------------------- */

  QuizInstance.prototype.renderProgress = function () {
    var self = this;
    var planned = this.plannedScreens();
    var current = this.state.screen === 'shortcut' ? 3 : this.state.screen;
    var index = Math.max(1, planned.indexOf(current) + 1);

    var row = el('div', 'sq-progress');

    var back = el('button', 'sq-progress__back', '← ' + (this.copy.backLabel || ''));
    back.type = 'button';
    back.disabled = this.history.length === 0;
    back.addEventListener('click', function () {
      self.back();
    });

    var label = el(
      'span',
      'sq-progress__label',
      fill(this.copy.progressLabel || '{current} / {total}', { current: index, total: planned.length })
    );

    row.appendChild(back);
    row.appendChild(label);

    var bar = el('div', 'sq-progress__bar');
    var barFill = el('div', 'sq-progress__bar-fill');
    barFill.style.width = Math.round((index / planned.length) * 100) + '%';
    bar.appendChild(barFill);

    this.app.appendChild(row);
    this.app.appendChild(bar);
  };

  /* ---------------------------- Questions ----------------------------- */

  QuizInstance.prototype.renderQuestion = function (n) {
    var self = this;
    var screen = this.data.screens['s' + n];
    var current = this.state.answers[n];

    this.renderProgress();

    if (n === 6 && screen.image) {
      var imageWrap = el('div', 'sq-question-image');
      var image = el('img');
      image.src = screen.image;
      image.alt = '';
      imageWrap.appendChild(image);
      this.app.appendChild(imageWrap);
    }

    this.app.appendChild(el('h3', 'sq-question', screen.question));
    if (screen.subtitle) this.app.appendChild(el('p', 'sq-subquestion', screen.subtitle));

    var imageOptions = screen.options.filter(function (o) {
      return o.imageSlot;
    });
    var listOptions = screen.options.filter(function (o) {
      return !o.imageSlot;
    });

    if (imageOptions.length) {
      var grid = el('div', 'sq-options sq-options--' + imageOptions.length);
      imageOptions.forEach(function (opt) {
        grid.appendChild(self.imageOption(n, opt, current));
      });
      this.app.appendChild(grid);
    }

    if (listOptions.length) {
      var list = el('div', 'sq-list' + (imageOptions.length ? ' sq-list--after-grid' : ''));
      listOptions.forEach(function (opt) {
        list.appendChild(self.listOption(n, opt, current));
      });
      this.app.appendChild(list);
    }

    // "Hoppa över, jag vet min underton" — below the answers on screen 3
    if (n === 3 && this.copy.shortcutLabel) {
      var shortcutWrap = el('div', 'sq-shortcut');
      var shortcutLink = el('button', 'sq-shortcut__link', this.copy.shortcutLabel);
      shortcutLink.type = 'button';
      shortcutLink.addEventListener('click', function () {
        self.goTo('shortcut');
      });
      shortcutWrap.appendChild(shortcutLink);
      this.app.appendChild(shortcutWrap);
    }

    var confirm = el('p', 'sq-microconfirm');
    confirm.setAttribute('data-microconfirm', '');
    this.app.appendChild(confirm);
  };

  QuizInstance.prototype.imageOption = function (n, opt, current) {
    var self = this;
    var btn = el('button', 'sq-option' + (opt.key === current ? ' is-selected' : ''));
    btn.type = 'button';

    var imageWrap = el('span', 'sq-option__image');
    if (opt.image) {
      var img = el('img');
      img.src = opt.image;
      img.alt = opt.label || '';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    } else {
      imageWrap.appendChild(el('span', 'sq-option__image--placeholder', opt.label));
    }
    btn.appendChild(imageWrap);

    // Skin tone dots under the image (screen 2)
    var swatches = (opt.swatches || []).filter(Boolean);
    if (swatches.length) {
      var dots = el('span', 'sq-option__swatches');
      swatches.forEach(function (color) {
        var dot = el('span', 'sq-option__swatch');
        dot.style.backgroundColor = color;
        dots.appendChild(dot);
      });
      btn.appendChild(dots);
    }

    btn.appendChild(el('span', 'sq-option__label', opt.label));
    if (opt.sub) btn.appendChild(el('span', 'sq-option__subtext', opt.sub));

    btn.addEventListener('click', function () {
      self.answer(n, opt.key, btn);
    });
    return btn;
  };

  QuizInstance.prototype.listOption = function (n, opt, current) {
    var self = this;
    var btn = el('button', 'sq-list-option' + (opt.key === current ? ' is-selected' : ''));
    btn.type = 'button';
    btn.appendChild(el('span', 'sq-list-option__label', opt.label));
    if (opt.sub) btn.appendChild(el('span', 'sq-list-option__sub', opt.sub));
    btn.addEventListener('click', function () {
      self.answer(n, opt.key, btn);
    });
    return btn;
  };

  QuizInstance.prototype.answer = function (n, key, btn) {
    if (this.locked) return;
    this.locked = true;

    var self = this;
    this.state.answers[n] = key;
    if (n === 3) this.state.knownUndertone = null;

    var selected = this.app.querySelectorAll('.is-selected');
    for (var i = 0; i < selected.length; i++) selected[i].classList.remove('is-selected');
    btn.classList.add('is-selected');

    var confirm = this.app.querySelector('[data-microconfirm]');
    if (confirm) confirm.textContent = '✓';

    setTimeout(function () {
      self.goTo(self.nextScreen(n));
    }, ADVANCE_DELAY);
  };

  /* --------------------- Shortcut: known undertone --------------------- */

  QuizInstance.prototype.renderShortcut = function () {
    var self = this;
    this.renderProgress();
    this.app.appendChild(el('h3', 'sq-question', this.copy.shortcutQuestion));

    var picker = el('div', 'sq-shortcut-picker');

    this.data.screens.s3.shortcutOptions.forEach(function (opt) {
      var btn = el(
        'button',
        'sq-shortcut-circle' + (self.state.knownUndertone === opt.key ? ' is-selected' : '')
      );
      btn.type = 'button';
      btn.appendChild(el('span', 'sq-shortcut-circle__dot sq-shortcut-circle__dot--' + opt.key));
      btn.appendChild(el('span', 'sq-shortcut-circle__label', opt.label));
      btn.appendChild(el('span', 'sq-shortcut-circle__desc', opt.desc));

      btn.addEventListener('click', function () {
        if (self.locked) return;
        self.locked = true;
        self.state.knownUndertone = opt.key;
        delete self.state.answers[3];
        delete self.state.answers[4];
        delete self.state.answers[5];
        btn.classList.add('is-selected');
        setTimeout(function () {
          self.goTo(6);
        }, ADVANCE_DELAY);
      });

      picker.appendChild(btn);
    });

    this.app.appendChild(picker);
  };

  /* ------------------------------ Result ------------------------------ */

  QuizInstance.prototype.formulaFor = function (undertone, guide) {
    if (guide === false) return 'clear';
    if (undertone === 'kall') return 'dark_cool';
    if (undertone === 'varm') return 'dark_warm';
    // Neutral undertone + wants guide colour -> formula chosen in the theme editor
    if (guide === true && this.data.neutralGuide && this.data.neutralGuide !== 'clear') return this.data.neutralGuide;
    return 'clear';
  };

  QuizInstance.prototype.computeResult = function () {
    var a = this.state.answers;
    var R = this.data.results;
    var undertone = this.undertone();
    var depth = this.depth();

    var chosen = a[6];
    var path = chosen;
    if (path === 'suggest') path = this.wantsGradual() ? 'gradual' : 'mousse';
    var fromMousse = false;
    if (path === 'mousse' && this.wantsGradual()) {
      path = 'gradual';
      fromMousse = chosen === 'mousse';
    }

    var guide = null;
    if (this.needsScreen7()) {
      if (a[7] === 'ja') guide = true;
      if (a[7] === 'nej') guide = false;
    }

    var r = {
      undertone: undertone,
      depth: depth,
      path: path,
      primary: null,
      applyKeys: [],
      alternatives: [],
      reasonParts: [R.undertone[undertone]],
      notes: []
    };

    if (path === 'spray' || path === 'controlled' || path === 'face') {
      // Device: undertone decides formula, need decides device
      var formula = this.formulaFor(undertone, guide);
      var whyKey = formula === 'clear' ? (guide === false ? 'clear_noguide' : 'clear_neutral') : formula;
      var device = path === 'spray' ? 'pro' : 'one';

      r.primary = formula;
      r.applyKeys = [device, formula, 'headband'];
      r.reasonParts.push(fill(R.why[whyKey], { product: this.title(formula) }));
      r.reasonParts.push(fill(R.device[device], { device: this.title(device) }));

      // Neutral undertone + guide colour: Clear (no guide colour) is shown as an alternative
      if (undertone === 'neutral' && guide === true && formula !== 'clear') {
        r.alternatives.push('clear');
        if (this.data.noteNeutralGuide) r.notes.push(fill(this.data.noteNeutralGuide, { product: this.title('clear') }));
      }

      if (path === 'spray') {
        r.alternatives.push('go');
        r.notes.push(fill(R.notes.go, { product: this.title('go') }));
      }
      if (path === 'face') {
        r.alternatives.push('night_mask');
        r.notes.push(fill(R.notes.night_mask, { product: this.title('night_mask') }));
      }
    } else if (path === 'mousse') {
      // Mousse: guide colour + depth + undertone decide
      //   - no guide colour            -> Mousse Clear
      //   - depth 4 (deep skin + more) -> Mousse Ultra Dark
      //   - cool undertone, depth 3+   -> Mousse Ultra Dark (green guide colour)
      //   - otherwise                  -> Mousse Dark
      var mousse;
      if (guide === false) mousse = 'mousse_clear';
      else if (depth === 4 || (undertone === 'kall' && depth >= 3)) mousse = 'mousse_ultra_dark';
      else mousse = 'mousse_dark';

      var mousseWhy = mousse;
      if (mousse === 'mousse_ultra_dark') mousseWhy = undertone === 'kall' ? 'ultra_cool' : 'ultra_deep';

      r.primary = mousse;
      r.applyKeys = [mousse, 'mitt', 'headband'];
      r.reasonParts.push(fill(R.why[mousseWhy], { product: this.title(mousse) }));
    } else {
      // Gradual
      if (fromMousse) r.reasonParts.push(R.notes.gradual_from_mousse);
      r.primary = 'gradual_lotion';
      r.applyKeys = ['gradual_lotion', 'headband'];
      r.reasonParts.push(fill(R.why.gradual, { product: this.title('gradual_lotion') }));
      r.notes.push(R.notes.gradual);
    }

    if (undertone === 'kall' && depth === 4) r.notes.push(R.notes.cool_deep);

    r.steps = [
      { label: this.copy.step1Label, keys: ['scrub', 'pads'], joiner: ' ' + (this.copy.orWord || 'eller') + ' ' },
      { label: this.copy.step2Label, keys: r.applyKeys, joiner: ' + ' },
      { label: this.copy.step3Label, keys: ['serum'], joiner: '' }
    ];

    return r;
  };

  QuizInstance.prototype.resultTitle = function (r) {
    var undertoneOption = this.data.screens.s3.shortcutOptions.filter(function (o) {
      return o.key === r.undertone;
    })[0];
    var undertoneLabel = (undertoneOption && undertoneOption.label) || r.undertone;

    var skinKey = this.state.answers[2];
    var skinOption = this.data.screens.s2.options.filter(function (o) {
      return o.key === skinKey;
    })[0];
    var skin = skinOption && skinOption.label ? skinOption.label.toLowerCase() : '';

    if (!skin) return undertoneLabel;
    return fill(this.copy.resultTitle || '{undertone}, {skin}', { undertone: undertoneLabel, skin: skin });
  };

  QuizInstance.prototype.productLink = function (key) {
    var p = this.product(key);
    if (p && p.url) {
      var link = el('a', 'sq-routine__product', this.title(key));
      link.href = p.url;
      return link;
    }
    return el('span', 'sq-routine__product', this.title(key));
  };

  QuizInstance.prototype.renderResult = function () {
    var self = this;
    var r = this.computeResult();
    this.lastResult = r;

    this.app.appendChild(el('p', 'sq-result__eyebrow', this.copy.resultEyebrow));
    this.app.appendChild(el('h3', 'sq-result__title', this.resultTitle(r)));
    this.app.appendChild(el('p', 'sq-result__body', r.reasonParts.filter(Boolean).join(' ')));

    var notes = r.notes.filter(Boolean);
    if (notes.length) this.app.appendChild(el('p', 'sq-result__notes', notes.join(' ')));

    // Routine: prepare, apply, prolong
    var routine = el('div', 'sq-routine');
    routine.appendChild(el('p', 'sq-routine__heading', this.copy.routineHeading));
    r.steps.forEach(function (step, i) {
      var row = el('div', 'sq-routine__step');
      row.appendChild(el('span', 'sq-routine__step-number', String(i + 1)));
      var text = el('span', 'sq-routine__step-text');
      text.appendChild(el('span', 'sq-routine__step-label', step.label + ' – '));
      step.keys.forEach(function (key, k) {
        if (k > 0) text.appendChild(document.createTextNode(step.joiner));
        text.appendChild(self.productLink(key));
      });
      row.appendChild(text);
      routine.appendChild(row);
    });
    this.app.appendChild(routine);

    // Buttons
    var cta = el('div', 'sq-cta');
    var addBtn = el('button', 'sq-cta__button', this.copy.addToCartLabel);
    addBtn.type = 'button';
    addBtn.addEventListener('click', function () {
      self.addRoutineToCart(r, addBtn);
    });
    cta.appendChild(addBtn);

    if (this.copy.saveProfileLabel) {
      var saveBtn = el('button', 'sq-cta__secondary', this.copy.saveProfileLabel);
      saveBtn.type = 'button';
      saveBtn.addEventListener('click', function () {
        self.renderEmailCapture(saveBtn, r);
      });
      cta.appendChild(saveBtn);
    }
    this.app.appendChild(cta);

    this.renderProductCards(r);
    this.renderFollowUp();

    // Change answers / restart
    var links = el('div', 'sq-restart');
    var editBtn = el('button', '', this.copy.editAnswersLabel);
    editBtn.type = 'button';
    editBtn.addEventListener('click', function () {
      self.back();
    });
    var restartBtn = el('button', '', this.copy.restartLabel);
    restartBtn.type = 'button';
    restartBtn.addEventListener('click', function () {
      self.reset();
      self.scrollToTop();
    });
    links.appendChild(editBtn);
    links.appendChild(restartBtn);
    this.app.appendChild(links);
  };

  /* -------------------------- Product cards --------------------------- */

  QuizInstance.prototype.renderProductCards = function (r) {
    var self = this;
    var keys = unique(['scrub', 'pads'].concat(r.applyKeys, ['serum']));
    var cards = [];

    keys.forEach(function (key) {
      if (self.product(key)) cards.push({ key: key, alt: false });
    });
    r.alternatives.forEach(function (key) {
      if (self.product(key)) cards.push({ key: key, alt: true });
    });

    if (!cards.length) return;

    var wrap = el('div', 'sq-products');
    if (this.copy.productsHeading) wrap.appendChild(el('p', 'sq-products__heading', this.copy.productsHeading));

    var grid = el('div', 'sq-products__grid');
    cards.forEach(function (card) {
      var p = self.product(card.key);
      var link = el('a', 'sq-product' + (card.alt ? ' sq-product--alt' : ''));
      link.href = p.url;

      var imageWrap = el('span', 'sq-product__image');
      if (p.image) {
        var img = el('img');
        img.src = p.image;
        img.alt = '';
        img.loading = 'lazy';
        imageWrap.appendChild(img);
      }
      link.appendChild(imageWrap);

      var info = el('span', 'sq-product__info');
      if (card.alt && self.copy.alternativeLabel) info.appendChild(el('span', 'sq-product__badge', self.copy.alternativeLabel));
      info.appendChild(el('span', 'sq-product__title', p.title));
      if (p.priceFormatted) info.appendChild(el('span', 'sq-product__price', p.priceFormatted));
      if (self.copy.viewProduct) info.appendChild(el('span', 'sq-product__link', self.copy.viewProduct));
      link.appendChild(info);

      grid.appendChild(link);
    });

    wrap.appendChild(grid);
    this.app.appendChild(wrap);
  };

  /* ------------------------------- Cart -------------------------------- */

  QuizInstance.prototype.cartKeys = function (r) {
    var keys = [this.product('scrub') ? 'scrub' : 'pads'];
    keys = keys.concat(r.applyKeys);
    keys.push('serum');
    return unique(keys);
  };

  QuizInstance.prototype.addRoutineToCart = function (r, btn) {
    var self = this;
    var items = [];

    this.cartKeys(r).forEach(function (key) {
      var p = self.product(key);
      if (p && p.variantId && p.inStock) items.push({ id: p.variantId, quantity: 1 });
    });

    if (!items.length) {
      alert(this.copy.cartEmpty);
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;

    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.textContent = '✓ ' + (self.copy.addedToCart || '');
        setTimeout(function () {
          window.location.href = routesRoot() + 'cart';
        }, 600);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
        alert(self.copy.cartError);
      });
  };

  /* ------------------------------- Email ------------------------------- */

  QuizInstance.prototype.renderEmailCapture = function (triggerBtn, r) {
    if (this.app.querySelector('[data-sq-email]')) return;
    var self = this;

    var form = el('form', 'sq-email');
    form.setAttribute('data-sq-email', '');

    var input = el('input');
    input.type = 'email';
    input.required = true;
    input.placeholder = this.copy.emailPlaceholder || '';

    var submit = el('button', '', '→');
    submit.type = 'submit';

    form.appendChild(input);
    form.appendChild(submit);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submitEmail(input.value, form, r);
    });

    triggerBtn.insertAdjacentElement('afterend', form);
    input.focus();
  };

  QuizInstance.prototype.submitEmail = function (email, form, r) {
    var self = this;
    var tags = ['newsletter', 'skin-quiz', 'underton-' + r.undertone, 'djup-' + r.depth];
    if (r.primary) tags.push('produkt-' + r.primary);

    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', tags.join(','));

    fetch(routesRoot() + 'contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function () {
        form.innerHTML = '';
        form.appendChild(el('span', 'sq-email__message', self.copy.emailSuccess));
      })
      .catch(function () {
        form.innerHTML = '';
        form.appendChild(el('span', 'sq-email__message', self.copy.emailError));
      });
  };

  /* --------------------- "Vad har gått fel förut?" --------------------- */

  QuizInstance.prototype.renderFollowUp = function () {
    var self = this;
    var screen = this.data.screens.s8;
    var tips = this.data.results.tips;
    if (!screen || !screen.question) return;

    var wrap = el('div', 'sq-followup');
    wrap.appendChild(el('p', 'sq-followup__question', screen.question));

    var chips = el('div', 'sq-followup__options');
    var tipsEl = el('div', 'sq-tips');

    function renderTips() {
      tipsEl.innerHTML = '';
      var selectedTips = self.state.issues
        .map(function (k) {
          return tips[k];
        })
        .filter(Boolean);
      if (!selectedTips.length) return;
      var list = el('ul');
      selectedTips.forEach(function (tip) {
        list.appendChild(el('li', '', tip));
      });
      tipsEl.appendChild(list);
    }

    screen.options.forEach(function (opt) {
      var chip = el('button', 'sq-followup__chip', opt.label);
      chip.type = 'button';
      if (self.state.issues.indexOf(opt.key) !== -1) chip.classList.add('is-selected');
      chip.addEventListener('click', function () {
        var idx = self.state.issues.indexOf(opt.key);
        if (idx === -1) {
          self.state.issues.push(opt.key);
          chip.classList.add('is-selected');
        } else {
          self.state.issues.splice(idx, 1);
          chip.classList.remove('is-selected');
        }
        renderTips();
      });
      chips.appendChild(chip);
    });

    wrap.appendChild(chips);
    wrap.appendChild(tipsEl);
    renderTips();
    this.app.appendChild(wrap);
  };

  /* ------------------------------- Init -------------------------------- */

  function initRoot(root) {
    if (!root || root.__skinQuiz) return;
    root.__skinQuiz = new QuizInstance(root);
  }

  function init() {
    var roots = document.querySelectorAll('.skin-quiz');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialise when the section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initRoot(e.target.querySelector('.skin-quiz'));
  });
})();